// DataManagement.js
import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { 
    Upload, 
    Trash2, 
    Download, 
    AlertTriangle, 
    Check, 
    X, 
    Filter,
    Calendar,
    Users,
    FileText,
    Database,
    RefreshCw
} from 'lucide-react';
import config from '../config';


const DataManagement = () => {
    const navigate = useNavigate();
    const [activeTab, setActiveTab] = useState('passports');
    const [isLoading, setIsLoading] = useState(false);
    const [data, setData] = useState([]);
    const [selectedItems, setSelectedItems] = useState([]);
    const [filters, setFilters] = useState({});
    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const [showImportModal, setShowImportModal] = useState(false);
    const [importFile, setImportFile] = useState(null);
    const [importMode, setImportMode] = useState('append'); // append or replace
    const [stats, setStats] = useState({});
    const [showReportModal, setShowReportModal] = useState(false);
const [importReport, setImportReport] = useState(null);

    // أضف هذا بعد السطر: const [stats, setStats] = useState({});
const [showDeleteFilters, setShowDeleteFilters] = useState(false);
const [deleteFilters, setDeleteFilters] = useState({
    dateRange: { from: '', to: '' },
    delegateId: '',
    companyId: '',
    passportStatus: '',
    receiveStatus: ''
});
const [companies, setCompanies] = useState([]);
const [delegates, setDelegates] = useState([]);

    // تعريف التبويبات المختلفة
// في DataManagement.js، غير التبويبات لتستخدم السيرفر الجديد:

const tabs = [
    {
        id: 'passports',
        name: 'الجوازات',
        icon: FileText,
        endpoint: '/api/passports',
        apiUrl: config.API_BASE_URL // تحديث للخادم الرئيسي
    },
    {
        id: 'delegates',
        name: 'المناديب',
        icon: Users,
        endpoint: '/api/delegates',
        apiUrl: config.API_BASE_URL // تحديث للخادم الرئيسي
    },
    {
        id: 'companies',
        name: 'الشركات',
        icon: Database,
        endpoint: '/api/companies',
        apiUrl: config.API_BASE_URL // تحديث للخادم الرئيسي
    },
    {
        id: 'professions',
        name: 'المهن',
        icon: RefreshCw,
        endpoint: '/api/professions',
        apiUrl: config.API_BASE_URL // تحديث للخادم الرئيسي
    }
];

    const currentTab = tabs.find(tab => tab.id === activeTab);

// استبدل useEffect الموجود بهذا
useEffect(() => {
    fetchData();
    fetchStats();
    fetchCompaniesAndDelegates(); // أضف هذا السطر
}, [activeTab]);

    // جلب البيانات
    const fetchData = async () => {
        try {
            setIsLoading(true);
            console.log('جلب البيانات من:', `${config.API_BASE_URL}${currentTab.endpoint}`);
            
            const response = await fetch(`${config.API_BASE_URL}${currentTab.endpoint}`);
            const result = await response.json();
            
            console.log('البيانات المستلمة:', result);
            console.log('نوع البيانات:', typeof result);
            console.log('هل هي مصفوفة؟', Array.isArray(result));
            
            if (Array.isArray(result) && result.length > 0) {
                console.log('أول عنصر:', result[0]);
                console.log('مفاتيح أول عنصر:', Object.keys(result[0]));
            }
            
            setData(Array.isArray(result) ? result : []);
        } catch (error) {
            console.error('خطأ في جلب البيانات:', error);
            setData([]);
        } finally {
            setIsLoading(false);
        }
    };

    // جلب إحصائيات البيانات
    const fetchStats = async () => {
        try {
            const response = await fetch(`${currentTab.apiUrl}${currentTab.endpoint}/stats`);
            const result = await response.json();
            setStats(result);
        } catch (error) {
            console.error('خطأ في جلب الإحصائيات:', error);
        }
    };

    // أضف هذا بعد دالة fetchStats
const fetchCompaniesAndDelegates = async () => {
    try {
        if (activeTab === 'passports') {
            const [companiesRes, delegatesRes] = await Promise.all([
                fetch(`${config.PASSPORT_API_URL}/api/companies`),
                fetch(`${config.PASSPORT_API_URL}/api/delegates`)
            ]);
            
            const companiesData = await companiesRes.json();
            const delegatesData = await delegatesRes.json();
            
            setCompanies(companiesData);
            setDelegates(delegatesData);
        }
    } catch (error) {
        console.error('خطأ في جلب البيانات المساعدة:', error);
    }
};


    // معالجة رفع الملف
    const handleFileUpload = (event) => {
        const file = event.target.files[0];
        if (file && file.type === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet') {
            setImportFile(file);
        } else {
            alert('يرجى اختيار ملف Excel صحيح (.xlsx)');
        }
    };


// تحميل نموذج Excel للاستيراد
// تحميل نموذج Excel للاستيراد
const downloadTemplate = () => {
    let templateData = [];
    
    switch (activeTab) {
        case 'passports':
            templateData = [{
                'مدة السفر': '3 أشهر',
                'الشركة': 'شركة البركة للتشغيل', 
                'حالة الجواز': 'قديم شركات',
                'الشركات السابقة': 'شركة النيل, شركة الهرم, شركة الأمل',
                'نتيجة اختبار القدرات': 'لائق',
                'الاسم العربي': 'أحمد محمد علي',
                'الاسم الإنجليزي': 'AHMED MOHAMED ALI',
                'رقم الجواز': 'A12345678',
                'الرقم القومي': '29501011234567',
                'مهنة الجواز': 'سائق',
                'مهنة السفر': 'سائق',
                'الحالة العسكرية': 'غير مطلوب',
                'تاريخ انتهاء الجواز': '2025-12-31',
                'العنوان': 'شارع النيل، الجيزة',
                'المحافظة': '',  // سيتم ملؤها تلقائياً من الرقم القومي
                'تاريخ الميلاد': '',  // سيتم ملؤها تلقائياً من الرقم القومي
                'العمر': '',  // سيتم ملؤها تلقائياً من الرقم القومي
                'المندوب': 'عصام أحمدين',
                'ارقام الهواتف': '01234567890, 01098765432',
                'نوع الرخصة': 'أولى',
                'تاريخ انتهاء الرخصة': '2025-06-30',
                'حالة الكشف الطبي': 'لائق',
                'تاريخ الكشف الطبي': '2024-01-15',
                'تاريخ النت': '2024-02-01',
                'مؤكد النت': 'نعم',
                'تاريخ تأكيد النت': '2024-02-01',
                'رقم الطلب': 'APP123456',
                'تاريخ البصمة': '2024-02-15',
                'تاريخ الفيزا': '2024-03-01',
                'تاريخ السفر': '2024-03-15',
                'حالة استلام الجواز': 'استلم العميل',
                'تاريخ الاستلام': '2024-01-10',
                'اسم الصديق': 'محمد أحمد',
                'هاتف الصديق': '01111111111',
                'الملاحظات': 'عميل مميز يحتاج متابعة',
                'نشط': 'نعم',
                'الحالة': 'نشط',
                'رقم الرحلة': '1',
                'معرف الجواز الأصلي': '',
                'تاريخ الإنشاء': '2024-01-01',
                'تاريخ التحديث': '2024-01-01',
                'تاريخ الأرشفة': ''
            }];
            break;
            
            case 'delegates':
                templateData = [{
                    'اسم المندوب': 'محمد أحمد السيد',
                    'المسمى الوظيفي': 'مندوب مبيعات',
                    'رقم الهاتف': '01234567890',
                    'الرصيد': 1000.50
                }];
                break;
                
            case 'companies':
                templateData = [{
                    'اسم الشركة': 'شركة الخليج للتشغيل',
                    'رقم الهاتف': '0233456789',
                    'العنوان': 'شارع التحرير، القاهرة',
                    'البريد الإلكتروني': 'info@gulf-company.com'
                }];
                break;
                
            case 'professions':
                templateData = [{
                    'اسم المهنة': 'سائق',
                    'الوصف': 'قيادة المركبات والشاحنات',
                    'الملاحظات': 'يتطلب رخصة قيادة سارية'
                }];
                break;
            
        default:
            templateData = [{ 'مثال': 'بيانات تجريبية' }];
    }

    // إنشاء ملف Excel
    import('xlsx').then(XLSX => {
        const worksheet = XLSX.utils.json_to_sheet(templateData);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, currentTab.name);
        
        const fileName = `نموذج_${currentTab.name}_شامل.xlsx`;
        XLSX.writeFile(workbook, fileName);
    });
};

    // تنفيذ الاستيراد
  // تنفيذ الاستيراد
const handleImport = async () => {
    if (!importFile) {
        alert('يرجى اختيار ملف للاستيراد');
        return;
    }

    const formData = new FormData();
    formData.append('file', importFile);
    formData.append('mode', importMode);

    try {
        setIsLoading(true);
        
        const response = await fetch(`${config.API_BASE_URL}${currentTab.endpoint}/import`, {
            method: 'POST',
            body: formData
        });

        const result = await response.json();
        
        if (result.success) {
            // حفظ تقرير الاستيراد لعرضه في modal
            setImportReport(result);
            setShowReportModal(true);
            
            setShowImportModal(false);
            setImportFile(null);
            fetchData();
            fetchStats();
        } else {
            alert('خطأ في الاستيراد: ' + result.error);
        }
    } catch (error) {
        console.error('خطأ في الاستيراد:', error);
        alert('حدث خطأ أثناء الاستيراد: ' + error.message);
    } finally {
        setIsLoading(false);
    }
};
    

    // حذف البيانات المحددة
 // استبدل دالة handleDelete الموجودة بهذا الكود
// استبدل دالة handleDelete بهذا الكود
const handleDelete = async () => {
    try {
        setIsLoading(true);
        
        console.log('المعرفات المحددة (خام):', selectedItems);
        
        // التحقق من المعرفات المحددة
        const validIds = selectedItems.filter(id => {
            const numId = parseInt(id);
            const isValid = !isNaN(numId) && numId > 0;
            if (!isValid) {
                console.warn('معرف غير صحيح:', id);
            }
            return isValid;
        }).map(id => parseInt(id));
        
        console.log('المعرفات الصحيحة:', validIds);
        console.log('الفلاتر المطبقة:', deleteFilters);
        
        // التحقق من وجود شروط للحذف
        const hasIds = validIds.length > 0;
        const hasFilters = deleteFilters && (
            deleteFilters.dateRange && (deleteFilters.dateRange.from || deleteFilters.dateRange.to) ||
            deleteFilters.delegateId ||
            deleteFilters.companyId ||
            deleteFilters.passportStatus ||
            deleteFilters.receiveStatus ||
            filters.period
        );
        
        console.log('يوجد معرفات:', hasIds);
        console.log('يوجد فلاتر:', hasFilters);
        
        if (!hasIds && !hasFilters) {
            alert('يرجى تحديد عناصر للحذف أو تطبيق فلاتر');
            setIsLoading(false);
            return;
        }
        
        const requestBody = {
            ids: validIds,
            filters: {
                ...deleteFilters,
                period: filters.period
            }
        };
        
        console.log('بيانات الطلب:', requestBody);
        console.log('URL الطلب:', `${config.API_BASE_URL}${currentTab.endpoint}/bulk-delete`);
        
        const response = await fetch(`${config.API_BASE_URL}${currentTab.endpoint}/bulk-delete`, {
            method: 'DELETE',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(requestBody)
        });

        console.log('استجابة الخادم:', response.status, response.statusText);
        
        const result = await response.json();
        console.log('نتيجة الحذف:', result);
        
        if (result.success) {
            alert(`تم حذف ${result.deleted} سجل بنجاح`);
            setShowDeleteModal(false);
            setSelectedItems([]);
            setDeleteFilters({
                dateRange: { from: '', to: '' },
                delegateId: '',
                companyId: '',
                passportStatus: '',
                receiveStatus: ''
            });
            fetchData();
            fetchStats();
        } else {
            alert('خطأ في الحذف: ' + (result.error || result.message || 'خطأ غير معروف'));
        }
    } catch (error) {
        console.error('خطأ في الحذف:', error);
        alert('حدث خطأ أثناء الحذف: ' + error.message);
    } finally {
        setIsLoading(false);
    }
};

    // تحديد/إلغاء تحديد جميع العناصر
    const toggleSelectAll = () => {
        if (selectedItems.length === data.length) {
            setSelectedItems([]);
        } else {
            const allIds = data.map(item => getItemId(item)).filter(id => id !== null);
            setSelectedItems(allIds);
        }
    };

    // الحصول على معرف العنصر حسب نوع البيانات
// الحصول على معرف العنصر حسب نوع البيانات
const getItemId = (item) => {
    console.log('العنصر المرسل:', item); // للتشخيص
    
    let id;
    switch (activeTab) {
        case 'passports':
            id = item.PassportID || item.passportId || item.passport_id || item.id;
            break;
        case 'delegates':
            id = item.DelegateID || item.delegateId || item.delegate_id || item.id;
            break;
        case 'companies':
            id = item.CompanyID || item.companyId || item.company_id || item.id;
            break;
        case 'professions':
            id = item.ProfessionID || item.professionId || item.profession_id || item.id;
            break;
        default:
            id = item.id;
    }
    
    console.log('المعرف المستخرج:', id); // للتشخيص
    
    // التأكد من أن المعرف رقم صحيح
    const numericId = parseInt(id);
    if (isNaN(numericId) || numericId <= 0) {
        console.error('معرف غير صحيح:', id, 'للعنصر:', item);
        return null;
    }
    
    return numericId;
};



    // الحصول على اسم العنصر للعرض
    const getItemDisplayName = (item) => {
        switch (activeTab) {
            case 'passports':
                return item.NameArabic || 'غير محدد';
            case 'delegates':
                return item.DelegateName || 'غير محدد';
            case 'companies':
                return item.CompanyName || 'غير محدد';
            case 'professions':
                return item.ProfessionName || 'غير محدد';
            default:
                return 'غير محدد';
        }
    };

// الحصول على تاريخ الإنشاء
const getItemCreatedDate = (item) => {
    let date;
    switch (activeTab) {
        case 'companies':
            date = item.UpdatedAt; // للشركات نستخدم UpdatedAt
            break;
        case 'professions':
            date = item.CreatedAt; // للمهن نستخدم CreatedAt
            break;
        default:
            date = item.CreatedAt || item.UpdatedAt;
    }
    return date ? new Date(date).toLocaleDateString('ar-EG') : 'غير محدد';
};


// الحصول على معلومات إضافية
const getItemExtraInfo = (item) => {
    switch (activeTab) {
        case 'passports':
            return item.PassportNumber || 'غير محدد';
        case 'delegates':
            return item.PhoneNumber || 'غير محدد';
        case 'companies':
            return item.PhoneNumber || 'غير محدد';
        case 'professions':
            return item.Description || 'مهنة';
        default:
            return 'غير محدد';
    }
};

    // تصدير البيانات إلى Excel
// تصدير البيانات إلى Excel
const handleExport = async () => {
    try {
        setIsLoading(true);
        
        // تحديد endpoint التصدير المناسب
        let exportEndpoint;
        if (activeTab === 'passports') {
            exportEndpoint = `${config.API_BASE_URL}${currentTab.endpoint}/export-full`;
        } else {
            exportEndpoint = `${config.API_BASE_URL}${currentTab.endpoint}/export`;
        }
            
        const response = await fetch(exportEndpoint, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({ filters })
        });

        if (!response.ok) {
            const errorText = await response.text();
            console.error('خطأ في التصدير:', response.status, errorText);
            throw new Error(`خطأ في التصدير: ${response.status} - ${errorText}`);
        }

        const blob = await response.blob();
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        
        let fileName;
        switch (activeTab) {
            case 'passports':
                fileName = `جوازات_شامل_${new Date().toISOString().split('T')[0]}.xlsx`;
                break;
            case 'delegates':  
                fileName = `مناديب_${new Date().toISOString().split('T')[0]}.xlsx`;
                break;
            case 'companies':
                fileName = `شركات_${new Date().toISOString().split('T')[0]}.xlsx`;
                break;
            case 'professions':
                fileName = `مهن_${new Date().toISOString().split('T')[0]}.xlsx`;
                break;
            default:
                fileName = `${currentTab.name}_${new Date().toISOString().split('T')[0]}.xlsx`;
        }
            
        link.download = fileName;
        link.click();
        
        // تنظيف الرابط
        window.URL.revokeObjectURL(url);
        
    } catch (error) {
        console.error('خطأ في التصدير:', error);
        alert('حدث خطأ أثناء التصدير: ' + error.message);
    } finally {
        setIsLoading(false);
    }
};


    // أضف هذا قبل return في المكون الرئيسي
const DeleteFiltersModal = ({ isOpen, onClose, onApply }) => {
    if (!isOpen) return null;

    return (
        <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex items-stretch md:items-center justify-center md:p-4">
            <div className="bg-white rounded-none md:rounded-lg shadow-xl w-full md:max-w-2xl h-[100dvh] md:h-auto overflow-y-auto">
                <div className="p-4 md:p-6">
                    <div className="flex items-center justify-between mb-4">
                        <h3 className="text-lg font-semibold">فلاتر الحذف المتقدم</h3>
                        <button
                            onClick={onClose}
                            className="text-gray-400 hover:text-gray-600"
                        >
                            <X size={24} />
                        </button>
                    </div>
                    
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                        {/* نطاق التاريخ */}
                        <div className="md:col-span-2">
                            <label className="block text-sm font-medium text-gray-700 mb-2">
                                نطاق تاريخ الإنشاء
                            </label>
                            <div className="flex flex-col sm:flex-row gap-2">
                                <input
                                    type="date"
                                    value={deleteFilters.dateRange.from}
                                    onChange={(e) => setDeleteFilters(prev => ({
                                        ...prev,
                                        dateRange: { ...prev.dateRange, from: e.target.value }
                                    }))}
                                    className="w-full border border-gray-300 rounded-lg px-3 py-2"
                                />
                                <span className="self-center">إلى</span>
                                <input
                                    type="date"
                                    value={deleteFilters.dateRange.to}
                                    onChange={(e) => setDeleteFilters(prev => ({
                                        ...prev,
                                        dateRange: { ...prev.dateRange, to: e.target.value }
                                    }))}
                                    className="w-full border border-gray-300 rounded-lg px-3 py-2"
                                />
                            </div>
                        </div>

                        {activeTab === 'passports' && (
                            <>
                                {/* المندوب */}
                                <div>
                                    <label className="block text-sm font-medium text-gray-700 mb-2">
                                        المندوب
                                    </label>
                                    <select
                                        value={deleteFilters.delegateId}
                                        onChange={(e) => setDeleteFilters(prev => ({ ...prev, delegateId: e.target.value }))}
                                        className="w-full border border-gray-300 rounded-lg px-3 py-2"
                                    >
                                        <option value="">جميع المناديب</option>
                                        {delegates.map(delegate => (
                                            <option key={delegate.DelegateID} value={delegate.DelegateID}>
                                                {delegate.DelegateName}
                                            </option>
                                        ))}
                                    </select>
                                </div>

                                {/* الشركة */}
                                <div>
                                    <label className="block text-sm font-medium text-gray-700 mb-2">
                                        الشركة
                                    </label>
                                    <select
                                        value={deleteFilters.companyId}
                                        onChange={(e) => setDeleteFilters(prev => ({ ...prev, companyId: e.target.value }))}
                                        className="w-full border border-gray-300 rounded-lg px-3 py-2"
                                    >
                                        <option value="">جميع الشركات</option>
                                        {companies.map(company => (
                                            <option key={company.CompanyID} value={company.CompanyID}>
                                                {company.CompanyName}
                                            </option>
                                        ))}
                                    </select>
                                </div>

                                {/* حالة الجواز */}
                                <div>
                                    <label className="block text-sm font-medium text-gray-700 mb-2">
                                        حالة الجواز
                                    </label>
                                    <select
                                        value={deleteFilters.passportStatus}
                                        onChange={(e) => setDeleteFilters(prev => ({ ...prev, passportStatus: e.target.value }))}
                                        className="w-full border border-gray-300 rounded-lg px-3 py-2"
                                    >
                                        <option value="">جميع الحالات</option>
                                        <option value="جديد">جديد</option>
                                        <option value="قديم شركات">قديم شركات</option>
                                    </select>
                                </div>

                                {/* حالة الاستلام */}
                                <div>
                                    <label className="block text-sm font-medium text-gray-700 mb-2">
                                        حالة الاستلام
                                    </label>
                                    <select
                                        value={deleteFilters.receiveStatus}
                                        onChange={(e) => setDeleteFilters(prev => ({ ...prev, receiveStatus: e.target.value }))}
                                        className="w-full border border-gray-300 rounded-lg px-3 py-2"
                                    >
                                        <option value="">جميع حالات الاستلام</option>
                                        <option value="لم يستلم">لم يستلم</option>
                                        <option value="استلم العميل">استلم العميل</option>
                                        <option value="استلم المندوب">استلم المندوب</option>
                                        <option value="استلم صديق">استلم صديق</option>
                                    </select>
                                </div>
                            </>
                        )}
                    </div>

                    <div className="flex flex-col-reverse md:flex-row gap-3 justify-end mt-6">
                        <button
                            onClick={onClose}
                            className="px-4 py-2 text-gray-700 bg-gray-100 rounded-lg hover:bg-gray-200"
                        >
                            إلغاء
                        </button>
                        <button
                            onClick={() => {
                                onApply();
                                onClose();
                            }}
                            className="px-4 py-2 bg-red-600 text-white rounded-lg hover:bg-red-700"
                        >
                            تطبيق وحذف
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};


    return (
        <div className="min-h-screen bg-gray-50 overflow-x-hidden" dir="rtl">
            {/* Header */}
            <div className="bg-white shadow-sm border-b">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                    <div className="flex flex-col md:flex-row justify-between md:items-center gap-3 min-h-16 py-3 md:py-0">
                        <div className="flex items-center">
                            <Database className="h-7 w-7 md:h-8 md:w-8 text-blue-600 ml-3" />
                            <div>
                                <p className="md:hidden text-xs text-blue-600 font-semibold">مسار / التحكم في البيانات</p>
                                <h1 className="text-xl md:text-2xl font-bold text-gray-900">إدارة البيانات</h1>
                            </div>
                        </div>
                        <button
                            onClick={() => navigate('/')}
                            className="bg-gray-600 hover:bg-gray-700 text-white px-4 py-3 md:py-2 rounded-xl md:rounded-lg transition duration-200 w-full md:w-auto"
                        >
                            العودة للرئيسية
                        </button>
                    </div>
                </div>
            </div>

            <div className="max-w-7xl mx-auto px-3 sm:px-6 lg:px-8 py-4 md:py-8">
                {/* التبويبات */}
                <div className="bg-white rounded-2xl md:rounded-lg shadow-sm mb-4 md:mb-6 overflow-hidden">
                    <div className="border-b border-gray-200">
                        <nav className="-mb-px flex overflow-x-auto gap-2 md:gap-0 md:space-x-8 px-2" dir="ltr">
                            {tabs.map((tab) => {
                                const Icon = tab.icon;
                                return (
                                    <button
                                        key={tab.id}
                                        onClick={() => setActiveTab(tab.id)}
                                        className={`flex items-center gap-2 py-3 md:py-4 px-4 md:px-6 border-b-2 font-medium text-sm transition-colors whitespace-nowrap shrink-0 ${
                                            activeTab === tab.id
                                                ? 'border-blue-500 text-blue-600'
                                                : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
                                        }`}
                                    >
                                        <Icon size={18} />
                                        {tab.name}
                                    </button>
                                );
                            })}
                        </nav>
                    </div>

                    {/* إحصائيات سريعة */}
                    <div className="p-3 md:p-6 bg-gray-50">
                        <div className="grid grid-cols-2 md:grid-cols-4 gap-3 md:gap-4">
                            <div className="bg-white p-4 rounded-lg border">
                                <div className="text-2xl font-bold text-blue-600">{data.length}</div>
                                <div className="text-sm text-gray-500">إجمالي السجلات</div>
                            </div>
                            <div className="bg-white p-4 rounded-lg border">
                                <div className="text-2xl font-bold text-green-600">{selectedItems.length}</div>
                                <div className="text-sm text-gray-500">سجلات محددة</div>
                            </div>
                            <div className="bg-white p-4 rounded-lg border">
                                <div className="text-2xl font-bold text-yellow-600">{stats.thisMonth || 0}</div>
                                <div className="text-sm text-gray-500">هذا الشهر</div>
                            </div>
                            <div className="bg-white p-4 rounded-lg border">
                                <div className="text-2xl font-bold text-purple-600">{stats.thisWeek || 0}</div>
                                <div className="text-sm text-gray-500">هذا الأسبوع</div>
                            </div>
                        </div>
                    </div>
                </div>

                {/* أدوات التحكم */}
                <div className="bg-white rounded-2xl md:rounded-lg shadow-sm p-4 md:p-6 mb-4 md:mb-6">
{/* استبدل قسم أزرار التحكم بهذا */}
<div className="flex flex-col lg:flex-row gap-4 justify-between">
    {/* أزرار الإجراءات */}
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:flex gap-3">
        <button
            onClick={() => setShowImportModal(true)}
            className="bg-green-600 hover:bg-green-700 text-white px-4 py-3 md:py-2 rounded-xl md:rounded-lg flex items-center justify-center gap-2 transition duration-200"
        >
            <Upload size={18} />
            استيراد من Excel
        </button>
        
        <button
            onClick={downloadTemplate}
            className="bg-purple-600 hover:bg-purple-700 text-white px-4 py-3 md:py-2 rounded-xl md:rounded-lg flex items-center justify-center gap-2 transition duration-200"
        >
            <Download size={18} />
            تحميل نموذج Excel
        </button>
        
        <button
        onClick={handleExport}
        className="bg-blue-600 hover:bg-blue-700 text-white px-4 py-3 md:py-2 rounded-xl md:rounded-lg flex items-center justify-center gap-2 transition duration-200"
    >
        <Download size={18} />
        تصدير شامل
    </button>

        <button
            onClick={() => setShowDeleteModal(true)}
            disabled={selectedItems.length === 0}
            className="bg-red-600 hover:bg-red-700 text-white px-4 py-3 md:py-2 rounded-xl md:rounded-lg flex items-center justify-center gap-2 transition duration-200 disabled:opacity-50"
        >
            <Trash2 size={18} />
            حذف المحدد ({selectedItems.length})
        </button>

        {/* زر الحذف المتقدم */}
        <button
            onClick={() => setShowDeleteFilters(true)}
            className="bg-orange-600 hover:bg-orange-700 text-white px-4 py-3 md:py-2 rounded-xl md:rounded-lg flex items-center justify-center gap-2 transition duration-200"
        >
            <Filter size={18} />
            حذف متقدم
        </button>
    </div>

    {/* فلاتر سريعة */}
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:flex gap-3">
        <select
            onChange={(e) => setFilters({...filters, period: e.target.value})}
            className="w-full border border-gray-300 rounded-xl md:rounded-lg px-3 py-3 md:py-2"
        >
            <option value="">كل الفترات</option>
            <option value="today">اليوم</option>
            <option value="week">هذا الأسبوع</option>
            <option value="month">هذا الشهر</option>
            <option value="year">هذا العام</option>
        </select>
        
        <button
            onClick={fetchData}
            className="bg-gray-600 hover:bg-gray-700 text-white px-4 py-3 md:py-2 rounded-xl md:rounded-lg flex items-center justify-center gap-2 transition duration-200"
        >
            <RefreshCw size={18} />
            تحديث
        </button>
    </div>
</div>
                </div>

                {/* جدول البيانات */}
                <div className="bg-white rounded-2xl md:rounded-lg shadow-sm overflow-hidden">
                    {isLoading ? (
                        <div className="flex justify-center items-center h-64">
                            <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-600"></div>
                            <span className="mr-3">جاري التحميل...</span>
                        </div>
                    ) : (
                        <>
                        <div className="hidden md:block overflow-x-auto">
                            <table className="w-full">
                            <thead className="bg-gray-50">
    <tr>
        <th className="px-6 py-3 text-right">
            <input
                type="checkbox"
                checked={selectedItems.length === data.length && data.length > 0}
                onChange={toggleSelectAll}
                className="rounded border-gray-300"
            />
        </th>
        <th className="px-6 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider">
            المعرف
        </th>
        <th className="px-6 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider">
            الاسم
        </th>
        <th className="px-6 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider">
            تاريخ الإنشاء
        </th>
        <th className="px-6 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider">
            معلومات إضافية
        </th>
        <th className="px-6 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider">
            الحالة
        </th>
    </tr>
</thead>
                                <tbody className="bg-white divide-y divide-gray-200">
    {data.map((item, index) => (
        <tr key={index} className="hover:bg-gray-50">
            <td className="px-6 py-4">
            <input
    type="checkbox"
    checked={(() => {
        const id = getItemId(item);
        return id !== null && selectedItems.includes(id);
    })()}
    onChange={(e) => {
        const id = getItemId(item);
        console.log('تغيير checkbox للعنصر:', item, 'المعرف:', id);
        
        if (id === null) {
            console.error('لا يمكن الحصول على معرف صحيح للعنصر:', item);
            alert('خطأ: لا يمكن تحديد هذا العنصر');
            return;
        }
        
        if (e.target.checked) {
            const newSelected = [...selectedItems, id];
            console.log('إضافة معرف:', id, 'القائمة الجديدة:', newSelected);
            setSelectedItems(newSelected);
        } else {
            const newSelected = selectedItems.filter(i => i !== id);
            console.log('إزالة معرف:', id, 'القائمة الجديدة:', newSelected);
            setSelectedItems(newSelected);
        }
    }}
    className="rounded border-gray-300"
/>
            </td>
            <td className="px-6 py-4 text-sm text-gray-900">
                {getItemId(item)}
            </td>
            <td className="px-6 py-4 text-sm text-gray-900">
                {getItemDisplayName(item)}
            </td>
            <td className="px-6 py-4 text-sm text-gray-500">
                {getItemCreatedDate(item)}
            </td>
            <td className="px-6 py-4 text-sm text-gray-500">
                {getItemExtraInfo(item)}
            </td>
            <td className="px-6 py-4">
                <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-green-100 text-green-800">
                    نشط
                </span>
            </td>
        </tr>
    ))}
</tbody>
                            </table>
                        </div>
                        <div className="md:hidden p-3 space-y-3">
                            <label className="flex items-center gap-2 bg-gray-50 border rounded-xl px-3 py-2 text-sm text-gray-700">
                                <input
                                    type="checkbox"
                                    checked={selectedItems.length === data.length && data.length > 0}
                                    onChange={toggleSelectAll}
                                    className="rounded border-gray-300"
                                />
                                تحديد كل السجلات المعروضة ({data.length})
                            </label>
                            {data.map((item, index) => {
                                const itemId = getItemId(item);
                                const checked = itemId !== null && selectedItems.includes(itemId);
                                return (
                                    <div key={index} className="bg-white border border-gray-200 rounded-2xl shadow-sm overflow-hidden">
                                        <div className="h-1.5 bg-gradient-to-l from-blue-500 to-emerald-500" />
                                        <div className="p-4 space-y-3">
                                            <div className="flex items-start justify-between gap-3">
                                                <div className="min-w-0">
                                                    <p className="text-xs text-gray-500">المعرف #{itemId}</p>
                                                    <h3 className="font-bold text-gray-900 break-words">{getItemDisplayName(item)}</h3>
                                                </div>
                                                <input
                                                    type="checkbox"
                                                    checked={checked}
                                                    onChange={(e) => {
                                                        if (itemId === null) {
                                                            alert('خطأ: لا يمكن تحديد هذا العنصر');
                                                            return;
                                                        }
                                                        if (e.target.checked) {
                                                            setSelectedItems([...selectedItems, itemId]);
                                                        } else {
                                                            setSelectedItems(selectedItems.filter(i => i !== itemId));
                                                        }
                                                    }}
                                                    className="rounded border-gray-300 mt-1"
                                                />
                                            </div>
                                            <div className="grid grid-cols-1 gap-2 text-sm">
                                                <div className="bg-gray-50 rounded-xl p-3"><span className="text-gray-500">تاريخ الإنشاء: </span><span className="font-medium">{getItemCreatedDate(item)}</span></div>
                                                <div className="bg-gray-50 rounded-xl p-3"><span className="text-gray-500">معلومات إضافية: </span><span className="font-medium break-words">{getItemExtraInfo(item)}</span></div>
                                            </div>
                                            <span className="inline-flex items-center px-2.5 py-1 rounded-full text-xs font-medium bg-green-100 text-green-800">نشط</span>
                                        </div>
                                    </div>
                                );
                            })}
                        </div>
                        </>
                    )}
                </div>
            </div>

            {/* نافذة الاستيراد */}
            {showImportModal && (
                <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex items-stretch md:items-center justify-center md:p-4">
                    <div className="bg-white rounded-none md:rounded-lg shadow-xl w-full md:max-w-md h-[100dvh] md:h-auto overflow-y-auto">
                        <div className="p-4 md:p-6">
                            <div className="flex items-center justify-between mb-4">
                                <h3 className="text-lg font-semibold">استيراد البيانات</h3>
                                <button
                                    onClick={() => setShowImportModal(false)}
                                    className="text-gray-400 hover:text-gray-600"
                                >
                                    <X size={24} />
                                </button>
                            </div>

                            <div className="space-y-4">
                                <div>
                                    <label className="block text-sm font-medium text-gray-700 mb-2">
                                        اختر ملف Excel
                                    </label>
                                    <input
                                        type="file"
                                        accept=".xlsx,.xls"
                                        onChange={handleFileUpload}
                                        className="w-full border border-gray-300 rounded-lg px-3 py-2"
                                    />
                                </div>

                                <div>
                                    <label className="block text-sm font-medium text-gray-700 mb-2">
                                        طريقة الاستيراد
                                    </label>
                                    <select
                                        value={importMode}
                                        onChange={(e) => setImportMode(e.target.value)}
                                        className="w-full border border-gray-300 rounded-lg px-3 py-2"
                                    >
                                        <option value="append">إضافة للبيانات الموجودة</option>
                                        <option value="replace">استبدال البيانات الموجودة</option>
                                    </select>
                                </div>

                                {importMode === 'replace' && (
                                    <div className="bg-red-50 border border-red-200 rounded-lg p-3">
                                        <div className="flex items-center">
                                            <AlertTriangle className="h-5 w-5 text-red-600 ml-2" />
                                            <span className="text-red-800 text-sm">
                                                تحذير: سيتم حذف جميع البيانات الموجودة واستبدالها بالبيانات الجديدة
                                            </span>
                                        </div>
                                    </div>
                                )}

                                <div className="flex flex-col-reverse md:flex-row gap-3 justify-end">
                                    <button
                                        onClick={() => setShowImportModal(false)}
                                        className="px-4 py-2 text-gray-700 bg-gray-100 rounded-lg hover:bg-gray-200"
                                    >
                                        إلغاء
                                    </button>
                                    <button
                                        onClick={handleImport}
                                        disabled={!importFile || isLoading}
                                        className="px-4 py-2 bg-green-600 text-white rounded-lg hover:bg-green-700 disabled:opacity-50"
                                    >
                                        {isLoading ? 'جاري الاستيراد...' : 'استيراد'}
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )}

            {/* نافذة تأكيد الحذف */}
            {showDeleteModal && (
                <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex items-stretch md:items-center justify-center md:p-4">
                    <div className="bg-white rounded-none md:rounded-lg shadow-xl w-full md:max-w-md h-[100dvh] md:h-auto overflow-y-auto">
                        <div className="p-6">
                            <div className="flex items-center justify-between mb-4">
                                <h3 className="text-lg font-semibold text-red-600">تأكيد الحذف</h3>
                                <button
                                    onClick={() => setShowDeleteModal(false)}
                                    className="text-gray-400 hover:text-gray-600"
                                >
                                    <X size={24} />
                                </button>
                            </div>

                            <div className="mb-6">
                                <div className="flex items-center mb-3">
                                    <AlertTriangle className="h-6 w-6 text-red-600 ml-2" />
                                    <span className="font-medium">هل أنت متأكد من حذف البيانات المحددة؟</span>
                                </div>
                                <p className="text-gray-600 text-sm">
                                    سيتم حذف {selectedItems.length} سجل نهائياً ولا يمكن التراجع عن هذا الإجراء.
                                </p>
                            </div>

                            <div className="flex flex-col-reverse md:flex-row gap-3 justify-end">
                                <button
                                    onClick={() => setShowDeleteModal(false)}
                                    className="px-4 py-2 text-gray-700 bg-gray-100 rounded-lg hover:bg-gray-200"
                                >
                                    إلغاء
                                </button>
                                <button
                                    onClick={handleDelete}
                                    disabled={isLoading}
                                    className="px-4 py-2 bg-red-600 text-white rounded-lg hover:bg-red-700 disabled:opacity-50"
                                >
                                    {isLoading ? 'جاري الحذف...' : 'حذف نهائي'}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            )}
           <DeleteFiltersModal 
    isOpen={showDeleteFilters}
    onClose={() => setShowDeleteFilters(false)}
    onApply={handleDelete}
/>

{/* نافذة تقرير الاستيراد */}
{showReportModal && importReport && (
    <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex items-stretch md:items-center justify-center md:p-4">
        <div className="bg-white rounded-none md:rounded-lg shadow-xl w-full md:max-w-4xl h-[100dvh] md:max-h-[90vh] overflow-hidden">
            <div className="p-4 md:p-6 h-full overflow-y-auto">
                <div className="flex items-center justify-between mb-4">
                    <h3 className="text-xl font-bold text-green-600">تقرير الاستيراد</h3>
                    <button
                        onClick={() => setShowReportModal(false)}
                        className="text-gray-400 hover:text-gray-600"
                    >
                        <X size={24} />
                    </button>
                </div>

                <div className="grid grid-cols-2 md:grid-cols-4 gap-3 md:gap-4 mb-6">
                    <div className="bg-blue-50 p-4 rounded-lg text-center">
                        <div className="text-2xl font-bold text-blue-600">{importReport.total}</div>
                        <div className="text-sm text-gray-600">إجمالي السجلات</div>
                    </div>
                    <div className="bg-green-50 p-4 rounded-lg text-center">
                        <div className="text-2xl font-bold text-green-600">{importReport.imported}</div>
                        <div className="text-sm text-gray-600">تم الاستيراد</div>
                    </div>
                    <div className="bg-yellow-50 p-4 rounded-lg text-center">
                        <div className="text-2xl font-bold text-yellow-600">{importReport.skipped}</div>
                        <div className="text-sm text-gray-600">تم التخطي</div>
                    </div>
                    <div className="bg-red-50 p-4 rounded-lg text-center">
                        <div className="text-2xl font-bold text-red-600">{importReport.errors}</div>
                        <div className="text-sm text-gray-600">فشل</div>
                    </div>
                </div>

                <div className="overflow-y-auto max-h-96">
                    {importReport.errorDetails && importReport.errorDetails.length > 0 && (
                        <div className="mb-6">
                            <h4 className="font-semibold text-red-600 mb-3">السجلات التي فشلت:</h4>
                            <div className="bg-red-50 rounded-lg p-4 max-h-40 overflow-y-auto">
                                {importReport.errorDetails.map((item, index) => (
                                    <div key={index} className="text-sm mb-2">
                                        <span className="font-medium">السطر {item.row}:</span> {item.name} 
                                        <span className="text-red-600 mr-2">({item.error})</span>
                                    </div>
                                ))}
                            </div>
                        </div>
                    )}

                    {importReport.skippedDetails && importReport.skippedDetails.length > 0 && (
                        <div className="mb-6">
                            <h4 className="font-semibold text-yellow-600 mb-3">السجلات المتخطية:</h4>
                            <div className="bg-yellow-50 rounded-lg p-4 max-h-40 overflow-y-auto">
                                {importReport.skippedDetails.map((item, index) => (
                                    <div key={index} className="text-sm mb-2">
                                        <span className="font-medium">السطر {item.row}:</span> {item.name} 
                                        <span className="text-yellow-600 mr-2">({item.reason})</span>
                                    </div>
                                ))}
                            </div>
                        </div>
                    )}

                    {importReport.importedDetails && importReport.importedDetails.length > 0 && (
                        <div className="mb-6">
                            <h4 className="font-semibold text-green-600 mb-3">عينة من السجلات المستوردة بنجاح:</h4>
                            <div className="bg-green-50 rounded-lg p-4 max-h-40 overflow-y-auto">
                                {importReport.importedDetails.slice(0, 10).map((item, index) => (
                                    <div key={index} className="text-sm mb-2">
                                        <span className="font-medium">{item.name}</span>
                                        <span className="text-green-600 mr-2">({item.passport})</span>
                                    </div>
                                ))}
                                {importReport.importedDetails.length > 10 && (
                                    <div className="text-sm text-gray-600 mt-2">
                                        ... و {importReport.importedDetails.length - 10} سجل آخر
                                    </div>
                                )}
                            </div>
                        </div>
                    )}
                </div>

                <div className="flex flex-col-reverse md:flex-row gap-3 justify-end mt-6">
                    <button
                        onClick={() => setShowReportModal(false)}
                        className="px-6 py-2 bg-gray-600 text-white rounded-lg hover:bg-gray-700"
                    >
                        إغلاق
                    </button>
                </div>
            </div>
        </div>
    </div>
)}
        </div>
    );
};

export default DataManagement;